import styled from "styled-components";

const DropDownContainer = styled.div`
  position: relative;
  top: 35px;
  padding-bottom: 1%;
  object-fit: cover;
  background-color: #2e2a27;
  box-shadow: 0 8px 8px #000000;
`;

export default DropDownContainer;
